import { z } from 'zod';

export type ShowSetting = z.infer<typeof ShowSetting>;
export const ShowSetting = z.enum(['colored', 'plain', 'hide']);

export type ShowSettings = z.infer<typeof ShowSettings>;
export const ShowSettings = z.object({
  untrackedCollections: ShowSetting.default('colored').catch('colored'),
  storageSize: ShowSetting.default('colored').catch('colored'),
  totalIndexSize: ShowSetting.default('colored').catch('colored'),
});

export type ToggleSettings = z.infer<typeof ToggleSettings>;
export const ToggleSettings = z.object({
  // index-manager polls the cluster constantly, so its own workload would otherwise dominate the
  // query shapes and slow queries of every page
  hideIndexManagerQueries: z.boolean().default(true).catch(true),
  // same for Atlas' platform agents, which run on every cluster and belong to nobody's application
  hideAtlasAgentQueries: z.boolean().default(true).catch(true),
});

export type InspectSearchParams = z.infer<typeof InspectSearchParams>;
export const InspectSearchParams = z.object({
  query: z.string().default('').catch(''),
  sort: z.enum(['name', 'size', 'indexSize']).default('name').catch('name'),
  ...ShowSettings.shape,
  ...ToggleSettings.shape,
});

export const INSPECT_DEFAULT_SEARCH = InspectSearchParams.parse({});
